import { connect } from 'react-redux'
import { hasFlag } from 'data/config/selectors'

export default connect(state => ({
  isNext: hasFlag(state, 'next'),
  isEditorNext: hasFlag(state, 'editor-next'),
}))
